export const email = 'amm.prod1@gmail.com';
export const tel = '+38 (099) 645 73 43';
export const telRaw = '+380996457343';
